/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GoLabMetadataValues } from '../../models/go-lab-metadata-values';

export interface GolabMetadataControllerGetGolabMetadataValues$Params {
}

export function golabMetadataControllerGetGolabMetadataValues(http: HttpClient, rootUrl: string, params?: GolabMetadataControllerGetGolabMetadataValues$Params, context?: HttpContext): Observable<StrictHttpResponse<GoLabMetadataValues>> {
  const rb = new RequestBuilder(rootUrl, golabMetadataControllerGetGolabMetadataValues.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GoLabMetadataValues>;
    })
  );
}

golabMetadataControllerGetGolabMetadataValues.PATH = '/golab-metadata/golabMetadataValues';
